import { AppointmentList } from "@/features/clinician/appointments/components/appointment-list";

function ClinicianAppointments() {
    return (
        <div className="px-4 py-8">
            <div className="container mx-auto">
                <h1 className="mb-4 text-2xl font-semibold">
                    Your appointments
                </h1>
                <AppointmentList />
            </div>
        </div>
    );
}

export default ClinicianAppointments;
